import { Form, Select } from "antd";
import PropTypes from "prop-types";

import ModalChoices from "@/components/Elements/ModalChoices";
import { useIsFormEnginePreviewMode } from "@/components/FormEngine/hooks/useIsFormEnginePreviewMode";
import { getIntValue } from "@/utilities/number";

import { SeverityFieldNames } from "./constants";
import {
  applySeverityGridRules,
  buildDefaultLevels,
  SeverityGridPreview,
} from "./gridUtils";
import { useDefectsFromSeverityGrid } from "./hooks/useDefectsFromSeverityGrid";
import { gridCriteriaMapper, simpleDropdownCriteriaMapper } from "./mappers";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;
const { useFormInstance, useWatch } = Form;

const SeverityCriteria = (props) => {
  const form = useFormInstance();
  const isPreviewMode = useIsFormEnginePreviewMode();
  const { gridDefects } = useDefectsFromSeverityGrid();
  const defect = useWatch(SeverityFieldNames.defect, form);

  if (isPreviewMode) {
    const choices = SeverityGridPreview.buildSampleCriteria();
    return <ModalChoices {...props} choices={choices} />;
  }

  const gridCriteria =
    gridDefects.find(({ slug }) => slug === defect)?.criteria ?? [];

  if (gridCriteria.length > 0) {
    const criteria = applySeverityGridRules(gridCriteria);
    const choices = criteria.map(gridCriteriaMapper);
    return <ModalChoices {...props} choices={choices} />;
  }

  // default to numeric levels simple dropdown list
  const defaultLevels = buildDefaultLevels().map(simpleDropdownCriteriaMapper);

  return (
    <Select {...props} value={getIntValue(props.value)}>
      {defaultLevels.map(({ value, name }) => (
        <Option key={value} value={getIntValue(value)}>
          {name}
        </Option>
      ))}
    </Select>
  );
};

SeverityCriteria.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SeverityCriteria;
